import Backbone from 'backbone';
import * as config from '../../../home24/core/config';

export default Backbone.Model.extend({
  defaults: {
    apiUrl: config.getBaseUrl() + config.get('search.suggest.url'),
    searchPhrase: '',
    searchPhraseLengthThreshold: config.getInt(
      'search.suggest.lengthThreshold'
    ),
    suggestions: [],
    suggestItemIndex: -1,
    submittedByClick: false,
    showSuggestionsBox: false,
    formSubmitted: false
  },

  initialize: function() {
    this.on('change:searchPhrase', function(model) {
      var searchPhrase = model.get('searchPhrase');

      if (
        !model.get('formSubmitted') &&
        searchPhrase.length > model.get('searchPhraseLengthThreshold')
      ) {
        model.getSuggestions();
      }
    });

    this.on('change:suggestions', function(model) {
      model.set({
        showSuggestionsBox: model.get('suggestions').length > 0
      });
    });
  },

  /**
   * Method loads search suggestions from server
   */
  getSuggestions: function() {
    $.ajax({
      type: 'GET',
      url: this.get('apiUrl'),
      context: this,
      data: {
        query: this.get('searchPhrase')
      },
      dataType: 'json',
      success: this.onGetSuggestionsSuccess
    });
  },

  onGetSuggestionsSuccess: function(data) {
    this.set({
      suggestions: data,
      suggestItemIndex: -1
    });
  },

  setSearchPhrase: function(phrase) {
    this.set({
      searchPhrase: phrase
    });
  },

  moveIndexUp: function() {
    if (this.get('showSuggestionsBox')) {
      var index = this.get('suggestItemIndex');

      index--;

      if (index < 0) {
        index = this.get('suggestions').length - 1;
      }

      this.set({
        suggestItemIndex: index
      });
    }
  },

  moveIndexDown: function() {
    if (this.get('showSuggestionsBox')) {
      var index = this.get('suggestItemIndex');

      index++;

      if (index >= this.get('suggestions').length) {
        index = 0;
      }

      this.set({
        suggestItemIndex: index
      });
    }
  },

  isSuggestionSelectedByKeyboard: function() {
    return !this.get('submittedByClick') && this.get('suggestItemIndex') >= 0;
  },

  setCurrentSearchPhrase: function() {
    this.set({
      searchPhrase: this.get('suggestions')[this.get('suggestItemIndex')].name
    });
  },
  setFormAsSubmitted: function() {
    this.set({
      formSubmitted: true
    });
  },
  isFormSubmitable: function() {
    return !this.get('formSubmitted');
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/searchField/searchFieldModel.js
 **/